import _ from 'lodash'
import { createAction, Middleware } from '@reduxjs/toolkit'
import { CalcEngine, CalcEngineState, CalcRegistry, CalculationRunType, hasEntries } from '@fusion-advantage/formlib'
import { setConceptStatusValidities, setConceptActivations } from './formSlice'
import { FormDispatch, FormRootState } from './formStore'
import { LoopDetector } from '@fusion-advantage/formlib'
import { submitStatusUpdates } from './submitStatusUpdates'
import { selectForm } from './selectForm'

export const runInitialCalculations = createAction<void>('calc/runInitialCalculations')

export class CalcMiddleware {
	private loopDetector = new LoopDetector()
	private _registry = new CalcRegistry()
	get registry(): CalcRegistry {
		return this._registry
	}
	middleware: Middleware<{}, FormRootState> = store => {
		const dispatch = store.dispatch as FormDispatch
		return next => action => {
			const prevState = store.getState()
			const result = next(action)
			const nextState = store.getState()
			let runType = CalculationRunType.Affected
			// always run initial calculations when explicitly requested
			if(runInitialCalculations.match(action)) {
				runType = CalculationRunType.Initial
			} else if(!nextState.calc.enabled) {
				return result
			}
			const engine = new CalcEngine(
				this.registry,
				this.loopDetector,
			)
			const exp = nextState.render.form?.export
			if(!exp) {
				// TODO dispatch properly
				alert('[formAssertion3] Expected export but null')
				return result
			}
			const engineState: CalcEngineState = {
				export: exp,
				concepts: selectForm(nextState).concepts,
				prevStatuses: prevState.form.conceptStatus,
				statuses: nextState.form.conceptStatus,
			}
			const rExec = engine.runCalculations({
				engineState,
				runType,
			})
			if(rExec.isErr()) {
				// TODO dispatch properly
				console.error('[formAssertion3 runCalculations]', rExec.error)
				alert(`Logged to console: [formAssertion3 runCalculations] ${JSON.stringify(rExec.error)}`)
				return result
			}
			const {
				statusUpdates,
				validityUpdates,
				activationUpdates,
				results,
			} = rExec.value
			if(statusUpdates.length > 0) {
				dispatch(submitStatusUpdates(statusUpdates))
			}
			if(hasEntries(validityUpdates)) {
				dispatch(setConceptStatusValidities(validityUpdates))
			}
			if(hasEntries(activationUpdates)) {
				store.dispatch(setConceptActivations(activationUpdates))
			}
			const runtimeErrs = [...results].filter(([_calcKey, rCalcExec]) => {
				if(rCalcExec.isErr()) return true
			})
			if(runtimeErrs.length > 0) {
				// TODO dispatch properly
				console.error('[formAssertion3 runCalculations]', runtimeErrs)
				alert(`Logged to console: [formAssertion3 runCalculations] ${JSON.stringify(runtimeErrs)}`)
			}
			return result
		}
	}
}
